import AXIOS from "../services/axios";
import axios from "axios";

export const createReference = async (payload) => {
  try {
    const { data } = await AXIOS.post(
      `${process.env.REACT_APP_API_PATH}/references/`,
      payload
    );
    return { data, error: null };
  } catch (error) {
    return { data: null, error };
  }
};

export const getReferencesByTask = async (taskId) => {
  try {
    const { data } = await AXIOS.get(
      `${process.env.REACT_APP_API_PATH}/references/?task=${taskId}`
    );
    return { data, error: null };
  } catch (error) {
    return { data: null, error };
  }
};

export const updateReference = async (referenceId, payload) => {
  try {
    const { data } = await AXIOS.patch(
      `${process.env.REACT_APP_API_PATH}/references/${referenceId}/`,
      payload
    );
    return { data, error: null };
  } catch (error) {
    return { data: null, error };
  }
};

export const deleteReference = async (referenceId) => {
  try {
    const { data } = await AXIOS.delete(
      `${process.env.REACT_APP_API_PATH}/references/${referenceId}/`
    );
    return { data, error: null };
  } catch (error) {
    return { data: null, error };
  }
};

export const createUserColor = async (payload) => {
  try {
    const { data } = await AXIOS.post(
      `${process.env.REACT_APP_API_PATH}/users/color_preferences`,
      payload
    );
    return { data, error: null };
  } catch (error) {
    return { data: null, error };
  }
};

export const getUserColor = async (userId) => {
  try {
    const { data } = await AXIOS.get(
      `${process.env.REACT_APP_API_PATH}/users/color_preferences`
    );
    return { data, error: null };
  } catch (error) {
    return { data: null, error };
  }
};

export const updateUserColor = async (userId, payload) => {
  try {
    const { data } = await AXIOS.patch(
      `${process.env.REACT_APP_API_PATH}/users/color_preferences`,
      payload
    );
    return { data, error: null };
  } catch (error) {
    return { data: null, error };
  }
};

export const createUserView = async (payload) => {
  try {
    const { data } = await AXIOS.post(
      `${process.env.REACT_APP_API_PATH}/dropdown/view/`,
      payload
    );
    return { data, error: null };
  } catch (error) {
    return { data: null, error };
  }
};

export const getUserViews = async () => {
  try {
    const { data } = await AXIOS.get(
      `${process.env.REACT_APP_API_PATH}/dropdown/view/`
    );
    return { data, error: null };
  } catch (error) {
    return { data: null, error };
  }
};

export const updateUserView = async (id, payload) => {
  try {
    const { data } = await AXIOS.patch(
      `${process.env.REACT_APP_API_PATH}/dropdown/view/${id}/`,
      payload
    );
    return { data, error: null };
  } catch (error) {
    return { data: null, error };
  }
};

export const getProjectLevelInfo = async (
  project,
  start_date,
  end_date,
  prop,
  signal,
  file
) => {
  const response = { data: null, error: null };
  try {
    const { data } = await AXIOS.get(
      `${
        process.env.REACT_APP_API_PATH
      }/report/?created_at_after=${start_date}&created_at_before=${end_date}&${
        prop ? `property=${prop}` : `project=${project.id}`
      }${file ? `&file=0` : ""}`,
      { signal }
    );
    response.data = data;
  } catch (err) {
    response.error = err.response;
  }
  return response;
};

export const getProjectLevelInfoExcel = async (
  project,
  start_date,
  end_date,
  file
) => {
  const response = { data: null, error: null };
  const token = localStorage.getItem("token");
  try {
    const { data } = await axios.get(
      `${
        process.env.REACT_APP_API_PATH
      }/report/?created_at_after=${start_date}&created_at_before=${end_date}&project=${
        project.id
      }${file ? `&file=0` : ""}`,
      {
        responseType: "blob",
        headers: {
          Authorization: "Bearer " + token,
        },
      }
    );
    response.data = data;
  } catch (err) {
    response.error = err.response;
  }
  return response;
};

export const getSummaryLevelBaiscInfo = async (project, prop) => {
  const response = { data: null, error: null };
  try {
    const { data } = await AXIOS.get(
      `${process.env.REACT_APP_API_PATH}/teamcomposition/?${
        prop ? `property=${prop}` : `project=${project.id}`
      }`
    );
    response.data = data;
  } catch (err) {
    response.error = err.response;
  }
  return response;
};

export const getSummaryLevelInfo = async (
  project,
  start_date,
  end_date,
  prop,
  team
) => {
  const response = { data: null, error: null };
  try {
    const { data } = await AXIOS.get(
      `${
        process.env.REACT_APP_API_PATH
      }/userreport/?created_at_after=${start_date}&created_at_before=${end_date}&${
        prop ? `property=${prop}` : `project=${project.id}`
      }&role=${team}`
    );
    response.data = data;
  } catch (err) {
    response.error = err.response;
  }
  return response;
};

export const getUserLevelInfoExcel = async (
  project,
  start_date,
  end_date,
  team,
  file
) => {
  const response = { data: null, error: null };
  const token = localStorage.getItem("token");
  try {
    const { data } = await AXIOS.get(
      `${
        process.env.REACT_APP_API_PATH
      }/userreport/?created_at_after=${start_date}&created_at_before=${end_date}&project=${
        project.id
      }${team?.id ? `&role=${team.id}` : ""}${file ? `&file=0` : ""}`,
      {
        responseType: "blob",
        headers: {
          Authorization: "Bearer " + token,
        },
      }
    );
    response.data = data;
  } catch (err) {
    response.error = err.response;
  }
  return response;
};

export const getUserLevelInfo = async (
  project,
  start_date,
  end_date,
  prop,
  team
) => {
  const response = { data: null, error: null };
  try {
    const { data } = await AXIOS.get(
      `${
        process.env.REACT_APP_API_PATH
      }/teamreport/?created_at_after=${start_date}&created_at_before=${end_date}&${
        prop ? `property=${prop}` : `project=${project.id}`
      }&role=${team}`
    );
    response.data = data;
  } catch (err) {
    response.error = err.response;
  }
  return response;
};

export const getProjectLevelPerformance = async (
  project,
  start_date,
  end_date,
  prop
) => {
  const response = { data: null, error: null };
  try {
    const { data } = await AXIOS.get(
      `${
        process.env.REACT_APP_API_PATH
      }/pagesummary/?created_at_after=${start_date}&created_at_before=${end_date}&${
        prop ? `property=${prop}` : `project=${project.id}`
      }`
    );
    response.data = data;
  } catch (err) {
    response.error = err.response;
  }
  return response;
};

export const getIndividualPageLevelPerformance = async (
  start_date,
  end_date,
  prop
) => {
  const response = { data: null, error: null };
  try {
    const { data } = await AXIOS.get(
      `${process.env.REACT_APP_API_PATH}/pagereport/?created_at_after=${start_date}&created_at_before=${end_date}&property=${prop}`
    );
    response.data = data;
  } catch (err) {
    response.error = err.response;
  }
  return response;
};

// ${prop ? `&property=${prop}` : ``}
export const getPaidVsOragnicData = async (
  project,
  start_date,
  end_date,
  prop
) => {
  const response = { data: null, error: null };
  try {
    const { data } = await AXIOS.get(
      `${
        process.env.REACT_APP_API_PATH
      }/percentagechart/?created_at_after=${start_date}&created_at_before=${end_date}&${
        prop ? `property=${prop}` : `project=${project.id}`
      }`
    );
    response.data = data;
  } catch (err) {
    response.error = err.response;
  }
  return response;
};

export const getIndividualPaidVsOragnicData = async (
  start_date,
  end_date,
  prop
) => {
  const response = { data: null, error: null };
  try {
    const { data } = await AXIOS.get(
      `${process.env.REACT_APP_API_PATH}/pagelevelchart/?created_at_after=${start_date}&created_at_before=${end_date}&property=${prop}`
    );
    response.data = data;
  } catch (err) {
    response.error = err.response;
  }
  return response;
};

export const getLineChartData = async (project, start_date, end_date, prop) => {
  const response = { data: null, error: null };
  try {
    const { data } = await AXIOS.get(
      `${
        process.env.REACT_APP_API_PATH
      }/linechart/?created_at_after=${start_date}&created_at_before=${end_date}&${
        prop ? `property=${prop}` : `project=${project.id}`
      }`
    );
    response.data = data;
  } catch (err) {
    response.error = err.response;
  }
  return response;
};

export const getAreaChartData = async (start_date, end_date, prop, type) => {
  const response = { data: null, error: null };
  try {
    const { data } = await AXIOS.get(
      `${process.env.REACT_APP_API_PATH}/pagelinechart/?created_at_after=${start_date}&created_at_before=${end_date}&property=${prop}&type=${type}`
    );
    response.data = data;
  } catch (err) {
    response.error = err.response;
  }
  return response;
};

export const getComparisonGraphInfo = async (project, start_date, end_date) => {
  const response = { data: null, error: null };
  try {
    const { data } = await AXIOS.get(
      `${process.env.REACT_APP_API_PATH}/chart/?created_at_after=${start_date}&created_at_before=${end_date}&project=${project.id}`
    );
    response.data = data;
  } catch (err) {
    response.error = err.response;
  }
  return response;
};

export const getIndividualComparisonGraphInfo = async (
  property,
  start_date,
  end_date
) => {
  const response = { data: null, error: null };
  try {
    const { data } = await AXIOS.get(
      `${process.env.REACT_APP_API_PATH}/pagechart/?created_at_after=${start_date}&created_at_before=${end_date}&property=${property}`
    );
    response.data = data;
  } catch (err) {
    response.error = err.response;
  }
  return response;
};

export const getSmarInfo = async (
  smar_group_id,
  start_date,
  end_date,
  report_id
) => {
  const response = { data: null, error: null };
  try {
    const { data } = await AXIOS.get(
      `${
        process.env.REACT_APP_API_PATH
      }/smarrank/?created_at_after=${start_date}&created_at_before=${end_date}&smar_id=${smar_group_id}${
        report_id ? `&generated_report_id=${report_id}` : ""
      }`
    );
    response.data = data;
  } catch (err) {
    response.error = err.response;
  }
  return response;
};

//&role=${team}
export const getIndividualPerformanceInfo = async (
  project,
  start_date,
  end_date,
  prop,
  team
) => {
  const response = { data: null, error: null };
  try {
    const { data } = await AXIOS.get(
      `${
        process.env.REACT_APP_API_PATH
      }/teamperformance/?created_at_after=${start_date}&created_at_before=${end_date}&${
        prop ? `property=${prop}` : `project=${project.id}`
      }&role=${team}`
    );
    response.data = data;
  } catch (err) {
    response.error = err.response;
  }
  return response;
};
